import clsx from 'clsx';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import AdminControls from '@lok/components/admin/AdminControls';
import PoweredByContinuum from '@lok/components/footer/PoweredByContinuum';
import CourseAssistant from '@lok/components/assistant/CourseAssistant';
import { useBranding } from '@lok/context/BrandingContext';

import { LeftSidebar } from './LeftSidebar';
import MainContainer from './components/MainContainer';
import Navbar from './Navbar';

const MainLayout = ({ hasRightSidebar, children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] =
    useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const [collapseSidebar, setCollapseSidebar] =
    useState(true);

  const location = useLocation();

  const isModulesLessonsPage =
    location.pathname.includes('/modules/');
  const isLessonDetailsPage =
    /^\/modules\/[^/]+\/lessons\/[^/]+/.test(
      location.pathname
    );

  const { hasBackgroundImage: hasBgImage } = useBranding();

  // When a brand bg image is set we drop both panels so the image is
  // actually visible (two stacked /90 panels compose to ~99% opacity and hide
  // it). Its 60% readability tint is painted by the fixed background layer
  // (.has-scrim), so it stays put when the page is scrolled past its end.
  let outerPanelBg;
  if (hasBgImage) {
    outerPanelBg = '';
  } else if (isModulesLessonsPage) {
    outerPanelBg = 'bg-white/90 dark:bg-[#141A21]/90';
  } else {
    outerPanelBg = 'bg-white/90 dark:bg-[#111D2C]/90';
  }

  const innerPanelBg =
    hasBgImage || isModulesLessonsPage
      ? ''
      : 'bg-white/90 dark:bg-[#111D2C]/90';

  return (
    <MainContainer>
      <div
        className={clsx('brand-bg-overlay', { 'has-scrim': hasBgImage })}
        aria-hidden='true'
      />
      <Navbar
        toggleMobileMenu={toggleMobileMenu}
        collapseSidebar={collapseSidebar}
        setCollapseSidebar={setCollapseSidebar}
        isMobileMenuOpen={isMobileMenuOpen}
      />
      <LeftSidebar
        isMobileMenuOpen={isMobileMenuOpen}
        collapseSidebar={collapseSidebar}
      />
      <AdminControls />
      <main
        className={clsx(
          'relative h-auto pt-16 md:pt-20 min-h-[100vh]',
          outerPanelBg,
          { 'w-full': isModulesLessonsPage },
          {
            'md:ml-64': !collapseSidebar,
            'md:mr-[25%]': hasRightSidebar
          }
        )}
      >
        <div
          className={clsx('h-auto', innerPanelBg, {
            'w-full': isModulesLessonsPage
          })}
        >
          {children}
          {!isLessonDetailsPage && <PoweredByContinuum />}
        </div>
      </main>
      {/* CON-306: floating course assistant; renders nothing unless the
          backend reports it available. */}
      <CourseAssistant />
    </MainContainer>
  );
};

export default MainLayout;
